<template>
  <div class="discountCoupon">
    <mt-header :title="$t('discountCoupon')">
      <router-link to slot="left">
        <mt-button @click="$router.back(-1)">
          <img src="@/assets/back.png" height="20" width="20" slot="icon">
          {{ $t('back') }}
        </mt-button>
      </router-link>
      <call-phone slot="right" />
    </mt-header>
    <mt-navbar v-model="selected">
      <mt-tab-item id="0">{{ $t('toBeExchanged') }}</mt-tab-item>
      <mt-tab-item id="1">{{ $t('exchanged') }}</mt-tab-item>
      <mt-tab-item id="2">{{ $t('expired') }}</mt-tab-item>
    </mt-navbar>
    <mt-tab-container v-model="selected">
      <mt-tab-container-item id="0">
        <div class="noCoupons0" v-if="!coupon['0'].length">
          <img src="../../assets/noCoupons.png" width="200px">
          {{ $t('noToBeExchangedTips') }}
          <div class="bottom">
            <mt-button type="primary" @click="$router.push('/mine/inviteFriends')">{{
              $t("inviteFriendsNow")
            }}</mt-button>
          </div>
        </div>
        <div v-for="(item, index) in coupon['0']" :key="index">
          <label class="mint-checklist-label" slot="title">
            <span class="mint-checkbox">
              <input class="mint-checkbox-input" type="checkbox" v-model="currentValue" :value="item.id">
              <span class="mint-checkbox-core"></span>
            </span>
            <div class="coupon1">
              <img src="../../assets/coupon_bg_1.png" width="100%">
              <div class="value">
                <div class="amount">{{ item.amount | formatMoney }}</div>
                <div class="content">
                  <div class="expireDate">{{$t('validUntil')}} {{ item.expireDate }}</div>
                  <div class="remark">{{ item.remark }}</div>
                </div>
              </div>
            </div>
          </label>
        </div>
        <div class="bottom" v-if="coupon['0'].length">
          <mt-button type="primary" size="large" plain :disabled="!currentValue.length" @click="submit('N')">{{
            $t("exchangeImmediately")
          }}</mt-button>
        </div>
      </mt-tab-container-item>
      <mt-tab-container-item id="1">
        <div class="noCoupons" v-if="!coupon['1'].length">
          {{ $t('noExchangedTips') }}
        </div>
        <div class="coupon1" v-for="(item, index) in coupon['1']" :key="index">
          <img src="../../assets/coupon_bg_2.png" width="100%">
          <div class="value">
            <div class="amount">{{ item.amount | formatMoney }}</div>
            <div class="content">
              <div class="expireDate">{{$t('validUntil')}} {{ item.expireDate }}</div>
              <div class="remark">{{ item.remark }}</div>
            </div>
          </div>
        </div>
      </mt-tab-container-item>
      <mt-tab-container-item id="2">
        <div class="noCoupons" v-if="!coupon['2'].length">
          {{ $t('noExpiredTips') }}
        </div>
        <div class="coupon2" v-for="(item, index) in coupon['2']" :key="index">
          <img src="../../assets/coupon_bg_3.png" width="100%">
          <div class="value">
            <div class="amount">{{ item.amount | formatMoney }}</div>
            <div class="content">
              <div class="expireDate">{{$t('validUntil')}} {{ item.expireDate }}</div>
              <div class="remark">{{ item.remark }}</div>
            </div>
          </div>
        </div>
      </mt-tab-container-item>
    </mt-tab-container>
  </div>
</template>

<script>
import callPhone from '@/components/callPhone.vue'
import { myCoupon, useMyCoupon } from '../../utils/api'
export default {
  name: 'DiscountCoupon',
  components: {
    callPhone
  },
  data() {
    return {
      selected: '0',
      currentValue: [],
      coupon: {
        '0': [],
        '1': [],
        '2': []
      }
    }
  },
  watch: {
    async selected(val) {
      this.$NProgress.start()
      await this.getMyCoupon(val)
      this.$NProgress.done()
    }
  },
  created() {
    this.init()
  },
  methods: {
    async init() {
      this.$indicator.open({
        spinnerType: "fading-circle",
      });
      this.$NProgress.start()
      await this.getMyCoupon(this.selected)
      this.$indicator.close();
      this.$NProgress.done()
    },
    // 获取优惠卷
    async getMyCoupon(status) {
      await this.$axios({
        method: "get",
        url: myCoupon,
        params: {
          status
        }
      })
        .then(async (e) => {
          if (e.status.code == "000") {
            this.coupon[status] = e.body
          } else {
            this.$toast(e.status.msg);
          }
        })
        .catch(() => {});
    },
    // 立即兑换
    async submit(confirm) {
      await this.$axios({
        method: "post",
        url: useMyCoupon + '?couponId=' + this.currentValue,
        params: {
          confirm,
        }
      })
        .then(async (e) => {
          if (e.status.code == "119") {
            this.$messagebox.confirm(e.status.msg || this.$t('couponPopupTips'), this.$t('couponPopupTitle'), {
              confirmButtonText: this.$t('confirm'),
              cancelButtonText: this.$t('cancel'),
            }).then(() => {
              this.submit('Y')
            }).catch(() => {});
          } else {
            this.getMyCoupon(this.selected)
            this.$toast(e.status.msg);
          }
        })
        .catch(() => {});
    }
  }
}
</script>

<style lang="scss" scoped>
.discountCoupon {
  .mint-tab-container {
    margin: 10px 0;
  }
  /deep/ .mint-tab-container-item {
    > div {
      position: relative;
      margin: 20px 15px 10px 15px;
      img {
        display: block;
      }
      .value {
        position: absolute;
        top: 0px;
        right: 0px;
        left: 22%;
      }
    }

    .noCoupons0 {
      margin-top: 30px;
      font-size: 15px;
      color: #A09F9F;
      text-align: center;
      img {
        margin: 0 auto;
        text-align: center;
        margin-bottom: 10px;
      }
      .bottom {
        padding: 30px 20px 20px 20px;
        .mint-button {
          padding: 0px 20px;
          border-radius: 6px;
          font-size: 15px;
        }
      }
    }
    .noCoupons {
      text-align: center;
      margin: 100px 0px;
      font-size: 15px;
      color: #A09F9F;
    }
  }
  .mint-tab-item {
    /deep/ .mint-tab-item-label {
      color: #606060;
    }
    &.is-selected {
      /deep/ .mint-tab-item-label {
        font-size: 14px;
        color: #2196F3;
        font-weight: bold;
      }
    }
  }
  .bottom {
    padding: 60px 20px 20px 20px;
    .mint-button {
      border-radius: 6px;
    }
  }
  /deep/ .mint-checklist-label {
    display: flex;
    .mint-checkbox {
      margin-right: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  /deep/ .value {
    height: 100%;
    display: flex;
    align-items: center;
    .amount {
      color: #FF623D;
      font-weight: bold;
      font-size: 20px;
      padding-right: 7px;
      margin-right: 7px;
      border-right: 1px solid #BFBFBF;
    }
    .content {
      flex: 1;
    }
    .expireDate {
      padding: 6px 0px 4px 0px;
    }
    .remark {
      font-size: 12px;
    }
  }
  .coupon2 {
    color: #CBCBCB !important;
    .amount {
      color: #CBCBCB !important;
    }
  }
}
</style>